import axios from "axios";
import { HttpClient, RequestParams } from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";

import { ACCESS_TOKEN, LANGUAGE_CODE } from "../../utils/helpers/constants";

import {
  IAddQuantity,
  ICreateProduct,
  IdAccounting,
  IImportExcelProduct,
  IImportExcelProductStore,
  IManageProductStore,
  IMatchQuantity,
  IUpdateProduct,
} from "../../models/product/request";
import { IProduct, IProductDetails, IQuantity } from "../../models/product/response";
import { IProductQuery } from "../../models/product/query";
import { IExportTrademarkExcel } from "../../models/trademark/request";
import { ITrademarkQuery } from "../../models/trademark/query";

class ProductService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getAllProducts = (query: IProductQuery, params?: RequestParams) =>
    this.http.request<IBaseListingResponse<IProduct>>({
      path: `/product`,
      method: "GET",
      query,
      ...params,
    });

  getProduct = (id: number, params?: RequestParams) =>
    this.http.request<IProductDetails>({
      path: `/product/${id}`,
      method: "GET",
      ...params,
    });

  createProduct = (data: ICreateProduct, params?: RequestParams) =>
    this.http.request<IProduct>({
      path: "/product",
      method: "POST",
      body: data,
      ...params,
    });
  setIdAccounting = (id: number, data: IdAccounting) =>
    this.http.request<IProduct>({
      path: `/product/match-accounting-id/${id}`,
      method: "PUT",
      body: data,
    });

  addQuantity = (id: number, data: IAddQuantity) =>
    this.http.request<IProduct>({
      path: `/product/add-quantity/${id}`,
      method: "PUT",
      body: data,
    });

  getQuantities = (id: number) =>
    this.http.request<IQuantity[]>({
      path: `/products/${id}/quantities`,
      method: "GET",
    });

  matchQuantity = (id: number, data: IMatchQuantity) =>
    this.http.request<IProduct>({
      path: `/product/match-quantity/${id}`,
      method: "PUT",
      body: data,
    });

  manageProductStore = (data: IManageProductStore, params?: RequestParams) =>
    this.http.request<IProduct>({
      path: "/product/manage",
      method: "POST",
      body: data,
      ...params,
    });
  importFromExcelProductStore = (
    data: IImportExcelProductStore,
    params?: RequestParams
  ) =>
    this.http.request<IProduct>({
      path: "/product/import-in-store",
      method: "POST",
      body: data,
      ...params,
    });

  importFromExcelProduct = (
    data: IImportExcelProduct,
    params?: RequestParams
  ) =>
    this.http.request<IProduct>({
      path: "/product/import/edit-price",
      method: "POST",
      body: data,
      ...params,
    });

  updateProduct = (id: number, data: IUpdateProduct, params?: RequestParams) =>
    this.http.request<IProduct>({
      path: `/product/${id}`,
      method: "PUT",
      body: data,
      ...params,
    });

  deleteProduct = (id: number, params?: RequestParams) =>
    this.http.request<IProduct>({
      path: `/product/${id}`,
      method: "DELETE",
      ...params,
    });

  exportExcel = (data: IExportTrademarkExcel, query: ITrademarkQuery) =>
    axios.post(` ${process.env.REACT_APP_BASE_API_URL}/product/export`, data, {
      headers: {
        authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN) ||
          sessionStorage.getItem(ACCESS_TOKEN)
          }`,
        "Content-Type": "application/json",
        "accept-language": `${localStorage.getItem(LANGUAGE_CODE) ??
          process.env.REACT_APP_DEFAULT_LANGUAGE
          }`,
      },
      params: query,
      responseType: "arraybuffer",
    });
  circulateProduct = (id: number, params?: RequestParams) =>
    this.http.request<IProduct>({
      path: `/product/circulate-price/${id}`,
      method: "PUT",
      ...params,
    });
}

export default ProductService;
